module.exports = __webpack_public_path__ + "@/assets/img/bot4.d9a1e052.png";